import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Dropdown, Table, Checkbox, Dimmer, Loader, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { loadReferenceData } from '~/form/actions'
import Api from '~/api'

class ListPipedriveProducts extends Component {
  state = {
    productCodes: Map(),
  }

  render() {
    let { pipeProducts, itemProducts, onAdd, productOptions, productsByCode } = this.props

    let { productCodes } = this.state

    let takenProducts = itemProducts.map(p => p.get('id'))

    pipeProducts = pipeProducts.filter(p => !takenProducts.contains(p.get('id')))

    if (!pipeProducts.size) return null

    return (
      <div className="products-pipedrive">
        <Table compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <span>Kohdista Pipedrive tuotteet</span>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
        </Table>
        <Table size="small" compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Koodi / Nimi" />
              <Table.HeaderCell style={{ width: 100 }} content="Hinta" />
              <Table.HeaderCell style={{ width: 100 }} content="Alennus" />
              <Table.HeaderCell style={{ width: 100 }} content="Loppuhinta" />
              <Table.HeaderCell style={{ width: 100 }} content=" " />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {pipeProducts.map(product => {
              let id = product.get('id')
              let name = product.get('name')
              let code = productCodes.get(id, product.get('product_code'))
              let validCode = productsByCode.has(code)
              let price = product.get('price')
              let discount = product.get('discount')
              let total = (price * (100 - discount)) / 100
              let info = `${code} / ${name}`

              return (
                <Table.Row key={id}>
                  <Table.Cell>
                    {validCode ? (
                      <span>{info}</span>
                    ) : (
                      <Dropdown
                        options={productOptions}
                        text={info}
                        noResultsMessage="Tuotteita ei löytynyt"
                        search
                        fluid
                        selection
                        selectOnBlur={false}
                        selectOnNavigation={false}
                        compact
                        closeOnChange
                        defaultUpward
                        onChange={(e, { value } = {}) => this.setState({ productCodes: productCodes.set(id, value) })}
                      />
                    )}
                  </Table.Cell>
                  <Table.Cell>{price}€</Table.Cell>
                  <Table.Cell>{discount}%</Table.Cell>
                  <Table.Cell>{total}€</Table.Cell>
                  <Table.Cell>
                    {validCode ? (
                      <button
                        className="button-plain"
                        onClick={e => e.preventDefault() & onAdd(product.set('product_code', code).toJS())}>
                        lisää tuote
                      </button>
                    ) : (
                      <span>valitse koodi</span>
                    )}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
      </div>
    )
  }
}

class ProductEditor extends Component {
  state = {
    products: List(),
    itemProducts: List(),
    loading: true,
    errorMessage: false,
  }

  async componentDidMount() {
    let { id } = this.props
    let { data, status } = await Api.get(`/order/${id}/product`, { includeAllProducts: true })

    if (!data.success || status !== 200) return this.setState({ errorMessage: data.message, loading: false })

    this.setState({
      products: fromJS(data.products.sort((p1, p2) => (parseInt(p1.code) > parseInt(p2.code) ? 1 : -1))),
      itemProducts: fromJS(data.itemProducts),
      loading: false,
    })
  }

  handleAdd = async productData => {
    let { id, disabled = false } = this.props

    if (disabled) return

    this.setState({ errorMessage: false, loading: true })

    let { itemProducts } = this.state
    let { data, status } = await Api.post(`/order/${id}/product`, productData)

    if (!data.success || status !== 200)
      return this.setState({ errorMessage: data.message || 'Jokin meni pieleen', loading: false })

    this.setState({
      itemProducts: itemProducts.push(fromJS(data.item)),
      loading: false,
    })
  }

  removeProduct = async product_id => {
    let { id, disabled = false } = this.props

    if (disabled) return

    this.setState({ errorMessage: false, loading: true })

    let { itemProducts } = this.state
    let { data, status } = await Api.post(`/order/${id}/product/${product_id}`, {})

    if (!data.success || status !== 200)
      return this.setState({ errorMessage: data.message || 'Jokin meni pieleen', loading: false })

    this.setState({
      itemProducts: itemProducts.filter(p => p.get('id') !== product_id),
      loading: false,
    })
  }

  render() {
    let { id, item, disabled = false, invoiceType } = this.props

    let { products, productsLoading, itemProducts, loading, errorMessage } = this.state

    let productOptions = products
      .toJS()
      .map(item => ({ key: item.code, text: `${item.code} / ${item.name}`, value: item.code }))

    let data = item.get('data', Map())
    let pipedrive = data.get('pipedrive', false)

    let productsByCode = products.reduce((mapped, p) => mapped.set(p.get('code'), p), Map())
    let initialInvoiced = invoiceType === 'no_front' ? 0 : invoiceType === 'half_front' ? 50 : 100

    let [total, totalDiscounted] = itemProducts.reduce(
      (values, p) => {
        let price = parseInt(p.get('price'))
        let discount = parseInt(p.get('discount'))
        let [t, td] = values

        t = t + price
        td = td + (price * (100 - discount)) / 100
        return [t, td]
      },
      [0, 0]
    )

    let totalInvoiced = (totalDiscounted / 100) * initialInvoiced
    totalInvoiced = Math.round(totalInvoiced * 100) / 100

    return (
      <div className="products-editor-wrapper">
        {errorMessage ? <Message content={errorMessage} color="red" size="tiny" /> : null}
        <div className="products-editor">
          {pipedrive ? (
            <ListPipedriveProducts
              pipeProducts={pipedrive.get('products', List())}
              productOptions={productOptions}
              productsByCode={productsByCode}
              itemProducts={itemProducts}
              onAdd={this.handleAdd}
            />
          ) : null}
          <Table size="small" compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Koodi / nimi" />
                <Table.HeaderCell style={{ width: 100 }} content="Hinta" />
                <Table.HeaderCell style={{ width: 100 }} content="Alennus" />
                <Table.HeaderCell style={{ width: 100 }} content="Loppuhinta" />
                <Table.HeaderCell style={{ width: 100 }} content="Laskutettu" />
                <Table.HeaderCell style={{ width: 100 }} content=" " />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {itemProducts.map(product => {
                let id = product.get('id')
                let code = product.get('productCode')
                let price = product.get('price')
                let discount = product.get('discount')
                let total = (price * (100 - discount)) / 100

                let invoiced = product.getIn(['data', 'invoiced'])

                if (!invoiced && invoiced !== 0) {
                  invoiced = (total / 100) * initialInvoiced
                  invoiced = Math.round(invoiced * 100) / 100
                }

                let productData = productsByCode.get(code, Map())

                return (
                  <Table.Row key={id}>
                    <Table.Cell>
                      {code}
                      {` / `}
                      {productData.get('name')}
                    </Table.Cell>
                    <Table.Cell>{price}€</Table.Cell>
                    <Table.Cell>{discount}%</Table.Cell>
                    <Table.Cell>{total}€</Table.Cell>
                    <Table.Cell>{invoiced}€</Table.Cell>
                    <Table.Cell>
                      {!disabled ? (
                        <button
                          className="button-plain button-plain--red"
                          onClick={e => e.preventDefault() & this.removeProduct(id)}>
                          poista
                        </button>
                      ) : null}
                    </Table.Cell>
                  </Table.Row>
                )
              })}
              <Table.Row style={{ opacity: '.7' }}>
                <Table.Cell align="right"></Table.Cell>
                <Table.Cell>{total} €</Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell>{totalDiscounted} €</Table.Cell>
                <Table.Cell>{totalInvoiced} €</Table.Cell>
                <Table.Cell></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <div className="products-editor-actions">
            <Dropdown
              options={productOptions}
              text="+ Lisää tuote"
              noResultsMessage="Tuotteita ei löytynyt"
              search
              fluid
              selection
              selectOnBlur={false}
              selectOnNavigation={false}
              loading={productsLoading}
              disabled={disabled}
              compact
              closeOnChange
              defaultUpward
              onChange={(e, { value } = {}) => this.handleAdd({ product_code: value })}
            />
          </div>
          <Dimmer active={loading} inverted>
            <Loader />
          </Dimmer>
        </div>
      </div>
    )
  }
}

export default ProductEditor
